import { call, put, takeEvery } from 'redux-saga/effects';

import * as rimmService from '../services';
import { setEntityData } from './slices';
import * as actions from './actions';

function* getRimmEntity({ payload }: ReturnType<typeof actions.getRimmEntity>) {
  try {
    const { data } = yield call(rimmService.fetchRimmEntity, payload);
    yield put(setEntityData({ data, entity: payload.entity }));
  } catch (e) {
    console.error(e);
  }
}

export default function* watchRimmSaga() {
  yield takeEvery(actions.getRimmEntity, getRimmEntity);
}
